export default String.raw`
{% comment -%}
{% assign showBrandOnly = false -%}

{% if products.Search != null -%}
    {% assign showBrandOnly = true -%}
{% endif -%}


<input type="hidden" name="showBrandOnly" id="showBrandOnly" value="{{showBrandOnly}}" data-categories="{{ page.BaseHref }}{{config.DefinedPages.ProductList.Url}}" data-currentbrand="{{currentBrandName}}">

<script>$('.products-page-js').addClass("no-category-ui");</script>
<header class="products-navigation-ui clear-after-ui flex-ui {% if page.GroupId == null and products.Search == null -%} no-on-mobile-ui {% elseif products.TotalItems == 0 -%} no-items-mobile-ui  {% endif -%} {% if settings.filterPanelView == 'up' -%} filters-up-ui expandable-mechanism-container-js {% endif -%} {% if settings.filterOption == 'filterOption-no' -%} filters-up-js {% endif -%}">
    <div class="f-left-ui breadcrumbs-container-ui">
        {% include 'partials/common/breadcrumbs.html' -%}
    </div>
    {% if products.FilteringOptions -%}
        <div class="sorting-views-container-ui f-right-ui clear-after-ui">
            {% if settings.filterPanelView == 'left' -%}
                <div class="btn-pure-ui f-left-ui filter-mobile-ui toggle-filter-mobile-js">
                    <i class="ti-filter va-mid-ui line-height-1-ui"></i>
                    <span class="va-mid-ui line-height-1-ui">{{translations.Filter}}</span>
                    <span class="counter-bg-ui counter-js {% if activeFiltersQuantity > 0  -%}  {% else -%} hidden-js {% endif -%}"><span class="counter-ui counterSpan-js">{{activeFiltersQuantity}}</span></span>
                </div>
            {% else -%}
                {% assign filtersOpened = false -%} 
                {% if settings.filterPanelView == 'up' -%}
                    {% if products.FilteringOptions.Results or settings.upFilterPanelView == 'opened' -%} 
                        {% assign filtersOpened = true -%} 
                    {% endif -%}
                {% endif -%}
                {% assign fo = products.FilteringOptions -%}
                {% assign selectedQuantity = 0 -%}
                {% for filter in fo.Filters -%}
                    {% unless filter.Field == 'MARK' and config.Reviews.Enabled == false -%}
                        {% for value in filter.Values -%}
                            {% if value.Selected -%}
                                {% assign selectedQuantity = selectedQuantity | Plus: 1 -%}
                            {% endif -%}
                        {% endfor -%}
                    {% endunless -%}
                {% endfor -%}
                <div class="sorting-options-ui f-left-ui basic-dropdown-ui wa-ui">
                    <button class="toggle-filters-button-ui toggle-filters-button-js btn-pure-ui expand-data-js dropdown-trigger-ui {% if selectedQuantity > 0 -%} {% comment -%} with-quantity-ui {% endcomment -%} {% endif -%} {% if filtersOpened -%} expanded-js {% endif -%}">
                        <span class="sorting-label-ui">
                            <i class="ti-filter sorting-options-icon-ui"></i>
                            <span class="filters-label-js {% if filtersOpened -%} hidden-js {% endif -%}">{{translations.Filter}}</span>
                            <span class="filters-label-js {% if filtersOpened == false -%} hidden-js {% endif -%}">{{translations.CloseFilters}}</span>
                        </span>
                    </button>
                    {% if selectedQuantity > 0 -%}
                        <span class="active-sorting-option-ui block-ui hidden-js">{{selectedQuantity}}</span>
                    {% endif -%}
                </div>
            {% endif -%}
            {% if products.TotalItems != 0 -%}
                <div class="sorting-options-ui f-left-ui basic-dropdown-ui">
                    <button class="btn-pure-ui open-dropdown-js dropdown-trigger-ui">
                        <span class="sorting-label-ui">
                            <i class="ti-arrow-down sorting-options-icon-ui"></i>
                            <span class="desktop-ui">{{ translations.Sorting }}</span>
                            <span class="mobile-ui">
                                {% assign activeSortingOption = -1 -%}
                                {% for sortingType in products.SortingOptions -%}
                                    {% if sortingType.Value == products.SelectedSorting -%}
                                        {% assign activeSortingOption = sortingType.Text -%}
                                    {% endif -%}
                                {% endfor -%}
                                {% if activeSortingOption != -1 -%}
                                    {{ activeSortingOption }}
                                {% else -%}
                                    {{ translations.Sorting }}
                                {% endif -%}
                            </span>
                        </span>
                        <span class="close-ui ti-close"></span>
                    </button>
                    <div class="dropdown-js hidden-js dropdown-container-ui to-right-ui">
                        <p class="dropdown-title-ui">{{ translations.Sorting }}</p>
                        <ul class="sort-dropdown-content-ui dropdown-content-ui" data-sorting-query="{{ products.SortingQueryGET }}">
                            {% assign activeSortingOption = -1 -%}
                            {% for sortingType in products.SortingOptions -%}
                                {% unless config.Reviews.Enabled == false and sortingType.Value == '11' -%}
                                    {% assign activeSortingOptionClass = '' -%}
                                    {% if sortingType.Value == products.SelectedSorting -%}
                                        {% assign activeSortingOptionClass = 'active-left-ui' -%}
                                        {% assign activeSortingOption = sortingType.Text -%}
                                    {% endif -%}
                                    <li class="{{activeSortingOptionClass}}" data-sorting-type="{{ sortingType.Value }}">{{ sortingType.Text }}</li>
                                {% endunless -%}
                            {% endfor -%}
                        </ul>
                    </div>
                    {% if activeSortingOption != -1 -%}
                        <span class="active-sorting-option-ui block-ui hidden-js">{{activeSortingOption}}</span>
                    {% endif -%}
                </div>
            {% endif -%}
			{% if settings.thresholds == 'no' -%}
				<div class="f-right-ui view-options-mobile-ui">
					<button aria-label="change-view-button" class="btn-pure-ui change-view-js change-view-ui {% if view == 'quick-shopping'-%} btn-active-js {% endif -%}" data-view="quick-shopping"><i class="ti-view-list icons-filtering-ui"></i></button>
					<button aria-label="change-view-button" class="btn-pure-ui change-view-js change-view-ui {% if view == 'list'-%} btn-active-js {% endif -%}" data-view="list"><i class="ti-view-list-alt icons-filtering-ui"></i></button>
					<button aria-label="change-view-button" class="btn-pure-ui change-view-js change-view-ui {% if view == 'grid'-%} btn-active-js {% endif -%}" data-view="grid"><i class="ti-view-grid icons-filtering-ui"></i></button>
				</div>
			{% endif -%}
        </div>
        {% if settings.filterPanelView == "up" -%}
            {% include 'partials/products/product-filters.html' -%}
        {% endif -%}
    {% endif -%}
    <div class="docket">
        {% if products.Search != null -%}
            {% for sortingType in products.SortingOptions -%}
                {% if products.SelectedSorting == sortingType.Value -%}  
                    {% if sortingType.Value == 9-%}
                        <span>{{translations.sortingStarter}} {{translations.Sorting_Type_1}}</span>
                    {% elsif sortingType.Value == 10 -%}
                        <span>{{translations.sortingStarter}} {{translations.Sorting_Type_2}}</span>
                    {% elsif sortingType.Value == 1 -%}
                        <span>{{translations.sortingStarter}} {{translations.Sorting_Type_3}}</span>
                    {% elsif sortingType.Value == 2 -%}
                        <span>{{translations.sortingStarter}} {{translations.Sorting_Type_4}}</span>
                    {% elsif sortingType.Value == 3 -%}
                        <span>{{translations.sortingStarter}} {{translations.Sorting_Type_5}}</span>
                    {% elsif sortingType.Value == 4 -%}
                        <span>{{translations.sortingStarter}} {{translations.Sorting_Type_6}}</span>
                    {% elsif sortingType.Value == 8 -%}
                        <span>{{translations.sortingStarter}} {{translations.Sorting_Type_7}}</span>
                    {% elsif sortingType.Value == 6 -%}
                        <span>{{translations.sortingStarter}} {{translations.Sorting_Type_8}}</span>
                    {% elsif sortingType.Value == 7 -%}
                        <span>{{translations.sortingStarter}} {{translations.Sorting_Type_9}}</span>
                    {% elsif sortingType.Value == 5 -%}
                        <span>{{translations.sortingStarter}} {{translations.Sorting_Type_10}}</span>
                    {% elsif sortingType.Value == 11 -%}
                        <span>{{translations.sortingStarter}} {{translations.Sorting_Type_11}}</span>
                    {% elsif sortingType.Value == 12 -%}
                        <span>{{translations.sortingStarter}} {{translations.Sorting_Type_12}}</span>
                    {% elsif sortingType.Value == 15 -%}
                        <span>{{translations.sortingStarter}} {{translations.Sorting_Type_13}}</span>
                    {% elsif sortingType.Value == 17 -%}
                        <span>{{translations.sortingStarter}} {{translations.Sorting_Type_14}}</span>
                    {% endif -%}
                {% endif -%}
            {% endfor -%}
        {% endif -%}
    </div>
</header>

<div class="selected-filters-ui">
    <div class="form-js selected-filters-js" >
        {% assign pricesExist = false -%}

        {% if products.FilteringOptions.PriceTo != null or products.FilteringOptions.PriceFrom != null  -%}
            {% assign pricesExist = true -%}
        {% endif -%}
        {% if activeFiltersKeysString != "" or pricesExist -%}
            <input type="hidden" name="__action" value="Get/SearchFilters">

            <button class="selected-filter-item-ui selected-filter-item-js" data-field="all">
                <i class="ti-close filter-delete-ui"></i>
                <span>{{translations.ResetFilters}}</span>
            </button>

            {% unless customer.HidePrices -%}
                {% if products.FilteringOptions.PriceFrom != null and products.FilteringOptions.PriceFrom > 0 -%}
                    <button class="selected-filter-item-ui selected-filter-item-js" data-field="$minPrice">
                        <i class="ti-close filter-delete-ui"></i>
                        <span>{{translations.PriceFrom}} <strong>{{products.FilteringOptions.PriceFrom}}</strong> {{customer.CurrencyExt}}</span>
                    </button>
                    <input aria-label="{{translations.PriceFrom}}" name="$minPrice" type="hidden" value="{{products.FilteringOptions.PriceFrom}}" maxlength="12">
                {% endif -%}

                {% if products.FilteringOptions.PriceTo != null -%}
                    <button class="selected-filter-item-ui selected-filter-item-js" data-field="$maxPrice">
                        <i class="ti-close filter-delete-ui"></i>
                        <span>{{translations.PriceTo}} <strong>{{products.FilteringOptions.PriceTo}}</strong> {{customer.CurrencyExt}}</span>
                    </button>
                    <input aria-label="{{translations.PriceTo}}" name="$maxPrice" type="hidden" value="{{products.FilteringOptions.PriceTo}}" maxlength="12">
                {% endif -%}
            {% endunless -%}

            {% if activeFiltersKeysString != "" -%}
                {% assign activeFiltersTab = activeFiltersKeysString | Split: "||" -%}
                {% for f in activeFiltersTab -%}
                    {% assign filterParams = f | Split: "|" -%}
                    <button type="button" class="selected-filter-item-ui selected-filter-item-js" data-field="{{filterParams[0]}}" data-value="{{filterParams[2]}}">
                        <i class="ti-close filter-delete-ui"></i>
                        <span>
                            {{filterParams[1]}}:
                            <strong>
                                {% if filterParams[0] == "REWARD" -%}
                                    {{ translations.PointsProduct }}
                                {% elseif filterParams[0] == "KOLOR" and settings.graphicColorFilter == 'yes' and color-filter.Content and color-filter.Content != '' -%}
                                    <label for="{{ filterParams[0] | H }}" class="checkbox-ui color-checkbox-ui" style="margin: 0; width: 17px; height: 17px; vertical-align: top;">
                                        <input name="{{ filterParams[0] | H }}" type="checkbox" value="{{ filterParams[2] | H }}" >
                                        {% for colorFilterValue in colorFilterValues -%}
                                            {% assign colorFilterValueArr = colorFilterValue | Split: '|' -%}
                                            {% assign colorFilterValueName = colorFilterValueArr[0] -%}
                                            {% assign colorFilterValueHash = colorFilterValueArr[1] -%}
                                            {% if colorFilterValueName == filterParams[2] -%}
                                                {% assign colorHash = colorFilterValueHash -%}
                                            {% endif -%}
                                        {% endfor -%}
                                        <span class="label-ui {% if colorHash == '#FFFFFF' or colorHash == '#ffffff' or colorHash == 'multicolor' -%} white-ui {% endif -%}" style="background: {% if colorHash == 'multicolor' -%}url({{config.Url}}css/img/multicolor.png){% else -%}{{colorHash}}{% endif -%}; color: transparent; width: 17px; height: 17px;"></span>
                                    </label>
                                {% else -%}
                                    {{filterParams[3]}}
                                {% endif -%}
                            </strong>
                        </span>
                    </button>
                    <input type="hidden" name="{{filterParams[0]}}" value="{{filterParams[2]}}">
                {% endfor -%}
            {% endif -%}
        {% endif -%}
    </div>
</div>
{% endcomment -%}
`